module.exports = __webpack_public_path__ + "img/logo-sidebar.09cd99ea.svg";